import { type Project } from "@overmap-ai/common"
import { selectProjectById, selectProjectsByIds } from "@overmap-ai/core"

import { appStore } from "../../store"
import { FilterModifier } from "./FilterModifier"

const deserializeProjectId = (filterValue: Project["uuid"]) => {
	const project = selectProjectById(filterValue)(appStore.getState())

	return project?.uuid
}

export const ProjectEqualsFilterModifier = FilterModifier.create<Project["uuid"], Project["uuid"]>({
	id: "project-equals",
	getApplyFn: (filterValue) => (value) => value === filterValue,
	render: () => "is",
	serialize: (filterValue) => filterValue,
	deserialize: deserializeProjectId,
})

export const ProjectNotEqualsFilterModifier = FilterModifier.create<Project["uuid"], Project["uuid"]>({
	id: "project-not-equals",
	getApplyFn: (filterValue) => (value) => value !== filterValue,
	render: () => "is not",
	serialize: (filterValue) => filterValue,
	deserialize: deserializeProjectId,
})

const deserializeProjectIds = (filterValue: Project["uuid"][]) => {
	const projects = selectProjectsByIds(filterValue)(appStore.getState())
	const foundProjectIds = projects.map((project) => project.uuid)

	return foundProjectIds.length > 0 ? foundProjectIds : undefined
}

export const ProjectIncludesFilterModifier = FilterModifier.create<Project["uuid"], Project["uuid"][]>({
	id: "project-includes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => filterValueSet.has(value)
	},
	render: () => "is any of",
	serialize: (filterValue) => filterValue,
	deserialize: deserializeProjectIds,
})

export const ProjectExcludesFilterModifier = FilterModifier.create<Project["uuid"], Project["uuid"][]>({
	id: "project-excludes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => !filterValueSet.has(value)
	},
	render: () => "is none of",
	serialize: (filterValue) => filterValue,
	deserialize: deserializeProjectIds,
})
